var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ isModal: _vm.isModal, wider: _vm.$route.meta.widerHeader },attrs:{"component":"Popup","open":_vm.visible}},[_c('div',{staticClass:"panel"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }